export default __webpack_public_path__ + "static/media/Faizan.ad9e52c7.png";